import classNames from 'classnames';
import { useOTSTranslation } from 'i18n/useOTSTranslation';

import styles from './styles.module.scss';

interface ICurrencyNoticeProps {
  className?: string
  currency: string
}

const CurrencyNotice = ({ className, currency }: ICurrencyNoticeProps) => {
  const { t } = useOTSTranslation('common');

  return (
    <div className={classNames(styles.noticeBlock, className)}>
      {`${t('resort.liftTickets.currencyText')} `}
      {currency}
    </div>
  );
};

export default CurrencyNotice;
